var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75276 17.8508C9.53276 17.1508 9.14276 15.2208 8.24276 14.0008C7.35276 12.7508 6.12276 11.8908 4.88276 11.0608C3.99784 10.5034 3.20785 9.80794 2.54276 9.00081C2.26276 8.67081 1.69276 8.06081 2.27276 7.94081C2.86276 7.82081 3.88276 8.40082 4.40276 8.62082C5.31276 9.00082 6.21276 9.44081 7.05276 9.96082L8.06276 8.26081C6.50276 7.23081 4.50276 6.32082 2.64276 6.05082C1.58276 5.89082 0.462763 6.11082 0.102763 7.26082C-0.217237 8.25082 0.292763 9.25082 0.872763 10.0308C2.24276 11.8608 4.37276 12.7408 5.96276 14.3208C6.30276 14.6508 6.71276 15.0408 6.91276 15.5008C7.12276 15.9408 7.07276 15.9708 6.60276 15.9708C5.36276 15.9708 3.81276 15.0008 2.80276 14.3608L1.79276 16.0608C3.32276 17.0008 5.88276 18.4708 7.75276 17.8508ZM18.8428 2.25081C19.0628 2.03081 19.0628 1.67081 18.8428 1.46081L17.5428 0.160815C17.4383 0.0594048 17.2984 0.00268555 17.1528 0.00268555C17.0071 0.00268555 16.8673 0.0594048 16.7628 0.160815L15.7428 1.18081L17.8228 3.26082M9.00276 7.92081V10.0008H11.0828L17.2328 3.85081L15.1528 1.77081L9.00276 7.92081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/Sign.f9f3eba92f1e12ea3417de9011379e10.svg";
export { ForwardRef as ReactComponent };